"use strict";

exports.__esModule = true;
exports.DashboardList = void 0;
var _uiSwitch = require("../../Theme/UiDesign/uiSwitch");
var _DashboardList = require("./DashboardList.legacy");
var _DashboardList2 = require("./DashboardList.modern");
// Flag-gated UI: `DashboardList.legacy` is the component as it is on master,
// `DashboardList.modern` the ui-charts-update rewrite. The nearest UiDesignProvider
// (ENABLE_MODERN_UI + the screen's flag) decides which one renders.
var DashboardList = exports.DashboardList = (0, _uiSwitch.uiSwitch)(_DashboardList.DashboardList, _DashboardList2.DashboardList, "DashboardList");